import moment from 'moment';
import UAParser from 'ua-parser-js';
import store from '../store/index';
import constant from '../const/index';
import { sciToDec } from './scientific-to-decimal';
import { getRouteAccessibility, getSectionAccessibility } from './check-access-rights';
import {
  getCaption,
  getFullDate,
  isIdentificatorType,
  onlyNumbersHandler,
} from './common';

export default {
  getDate: (value) => moment(value).format('DD.MM.YYYY'),

  getMonthAndDay: (value) => moment(value).format('DD.MM'),

  getUnixFullDateAndTime: (value) => {
    const date = new Date(value * 1000);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
  },

  getUnixDate: (value) => {
    const date = new Date(value * 1000);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  },

  getUnixMonthAndDay: (value) => {
    const date = new Date(value * 1000);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}.${month}`;
  },

  getUnixTime: (value) => {
    const date = new Date(value * 1000);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  },

  convertExponentialToDecimal: (exponentialNumber) => {
    // Преобразуем экспоненциальное число в строку
    const str = exponentialNumber.toString();
    // Находим индекс символа 'e' (экспоненты) в строке
    const eIndex = str.indexOf('e');
    // Если индекс равен -1, значит, символ 'e' не найден и число не является экспонентой
    // В этом случае возвращаем исходное число без изменений
    if (eIndex !== -1) {
      // Иначе, число является экспонентой
      // Заменяем символ 'e' (экспоненты) на точку '.', чтобы преобразовать экспоненциальное число в десятичное
      // Затем обрезаем строку так, чтобы оставить только нужное количество цифр после точки
      // Это делается путем нахождения позиции, до которой нужно обрезать строку
      // Позиция вычисляется как индекс символа 'e' плюс показатель степени плюс 2 (для двух дополнительных цифр после точки)
      return +str.replace('e', '.').slice(0, eIndex + +str.slice(eIndex + 1) + 2);
      // Перед str.replace() стоит унарный плюс '+', который преобразует строку обратно в число
      // Это необходимо, потому что replace() возвращает строку, а нам нужно вернуть число
    }
    return exponentialNumber;
  },


  getTime: (value) => moment(value).format('HH:mm:ss'),

  getParsedUA: (value) => UAParser(value),

  getMarketById: (value) => {
    const { markets } = store.state.currencies;
    const market = markets.find((e) => e.id === value);
    return market;
  },

  getOrderTypeById: (value) => {
    const { ORDER_TYPE_LIST } = constant.orders;
    const orderType = ORDER_TYPE_LIST.find((e) => e.id === value);
    return orderType;
  },

  downloadReport: async (data, file) => {
    const objectUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', file);
    document.body.appendChild(link);
    link.click();
  },
  getFileSize: (length) => {
    if (typeof length !== 'number') return 'unknown';
    if (length < 1024) return `${length} B`;
    if (length < 1048576) return `${(length / 1024).toFixed()} kB`;
    return `${(length / 1048576).toFixed(1)} mB`;
  },

  generatePassword: (from = 8, to = 16) => {
    const length = Math.floor(Math.random() * (to - from)) + from;
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_';
    const charactersLength = characters.length;
    do {
      result = '';
      // eslint-disable-next-line
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
    } while (!constant.users.PASSWORD_REGEXP_SIGNUP.test(result));
    return result;
  },

  sciToDec,
  getRouteAccessibility,
  getSectionAccessibility,
  getCaption,
  getFullDate,
  isIdentificatorType,
  onlyNumbersHandler,
};
